import { LinkContainer, LinkIconContainer } from "../styles"

import { Shipments } from "../../../../../../icons"
import { ShippingCostModalTrigger } from "../../ShippingCostModalTrigger"
import { api } from "../../../../../../api"
import { t } from "@lingui/macro"

type ShippingCostProps = {
  canQuote: boolean
  productID: string
  variantID: number
  quantity: number
  customMethods: api.stores.shippings.Get.Custom[]
  freeShippingAmount: api.stores.shippings.Get.FreeShipping
  productPrice: number
  currency: "ARS" | "BRL" | "MXN"
  freeShipping: boolean
}

export function ShippingCostLink({
  productID,
  variantID,
  quantity,
  customMethods,
  canQuote,
  freeShipping,
  freeShippingAmount,
  productPrice,
  currency,
}: ShippingCostProps) {
  return (
    <LinkContainer>
      <LinkIconContainer>
        <Shipments />
      </LinkIconContainer>
      <ShippingCostModalTrigger
        linkId="product-vip-shipping-cost-link"
        triggerTitle={t`Conocer costos y formas de envío`}
        productID={productID}
        variantID={variantID}
        quantity={quantity}
        customMethods={customMethods}
        canQuote={canQuote}
        freeShippingAmount={freeShippingAmount}
        freeShipping={freeShipping}
        productPrice={productPrice}
        currency={currency}
      />
    </LinkContainer>
  )
}
